import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {size} from "../../../models/size";
import {scrollTo} from "../../../service/ToolsService";

type SizeListProp = {
  sizes: size[],
  loading?: boolean,
  refresh: () => void,
}

export const SizeList = ({sizes, loading, refresh}: SizeListProp) => {
  const [del, setDel] = useState(undefined as undefined | size);

  const deleteSize = async (size: size) => {
    await ApiService.delete(`/size/${size.sizeId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th>Zone du corps</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={4} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && sizes.map((size: size, i: number) => (
          <tr key={i} className="align-middle">
            <td>{size.label}</td>
            <td>{size.bodyArea.map((ba) => ba.label).join(', ')}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(size.updatedAt ?? size.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/equipment/size/edit/${size.sizeId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(size)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteSize(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
